import { createContext } from 'react';

const CollapsibleHierarchyRowContext = createContext();

export default CollapsibleHierarchyRowContext;
